(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["listening-room"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.listening-room');
    roots.forEach((root) => {
      const buttons = root.querySelectorAll('[data-feeling]');
      const songs = root.querySelectorAll('[data-song]');
      const search = root.querySelector('[data-song-search]');
      const clear = root.querySelector('[data-clear-filter]');
      const empty = root.querySelector('[data-empty]');
      const shelf = root.querySelector('[data-song-grid]');
      const previous = root.querySelector('[data-shelf-previous]');
      const next = root.querySelector('[data-shelf-next]');
      const albumDetail = root.querySelector('[data-album-detail]');
      let feeling = 'all';
      let activeAlbum = '';

      const filterSongs = () => {
        const query = search ? search.value.trim().toLowerCase() : '';
        let visible = 0;
        songs.forEach((song) => {
          const tags = song.dataset.tags || '';
          const haystack = song.dataset.search || '';
          const matchesFeeling = activeAlbum ? song.dataset.album === activeAlbum : feeling === 'all' || tags.includes(feeling);
          const matchesQuery = !query || haystack.includes(query);
          song.hidden = !(matchesFeeling && matchesQuery);
          if (!song.hidden) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
        if (clear) clear.hidden = feeling === 'all' && !query;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          feeling = button.dataset.feeling || 'all';
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          filterSongs();
          root.querySelector('.listening-room__section--songs')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      search?.addEventListener('input', filterSongs);
      previous?.addEventListener('click', () => {
        shelf?.scrollBy({ left: -(shelf.clientWidth * 0.82), behavior: 'smooth' });
      });
      next?.addEventListener('click', () => {
        shelf?.scrollBy({ left: shelf.clientWidth * 0.82, behavior: 'smooth' });
      });
      clear?.addEventListener('click', () => {
        feeling = 'all';
        if (search) search.value = '';
        buttons.forEach((item) => {
          const active = item.dataset.feeling === 'all';
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        filterSongs();
      });

      const albumHandle = new URLSearchParams(window.location.search).get('album');
      if (albumHandle) {
        const albumCardHandle = albumHandle === 'healing-isnt-linear' ? 'healing-isn-t-linear' : albumHandle;
        const album = root.querySelector(`[data-album-handle="${CSS.escape(albumCardHandle)}"]`);
        if (album && albumDetail) {
          feeling = albumHandle;
          activeAlbum = albumHandle;
          root.classList.add('is-album-view');
          albumDetail.hidden = false;
          const sourceImage = album.querySelector('img');
          const art = albumDetail.querySelector('[data-album-detail-art]');
          if (sourceImage && art) art.innerHTML = `<img src="${sourceImage.src}" alt="${album.dataset.albumTitle || ''}">`;
          const title = albumDetail.querySelector('[data-album-detail-title]');
          const chapter = albumDetail.querySelector('[data-album-detail-chapter]');
          const story = albumDetail.querySelector('[data-album-detail-story]');
          if (title) title.textContent = album.dataset.albumTitle || '';
          if (chapter) chapter.textContent = album.dataset.albumChapter || '';
          if (story) story.textContent = album.dataset.albumStory || '';
          const primary = albumDetail.querySelector('[data-album-merch-primary]');
          const secondary = albumDetail.querySelector('[data-album-merch-secondary]');
          if (primary && album.dataset.merchUrl) {
            primary.href = album.dataset.merchUrl;
            primary.textContent = `${album.dataset.merchLabel || 'Shop matching merch'} →`;
            primary.hidden = false;
          }
          if (secondary && album.dataset.secondaryMerchUrl) {
            secondary.href = album.dataset.secondaryMerchUrl;
            secondary.textContent = `${album.dataset.secondaryMerchLabel || 'Explore more merch'} →`;
            secondary.hidden = false;
          }
          const songsHeading = root.querySelector('.listening-room__section--songs h2');
          if (songsHeading) songsHeading.textContent = `Songs from ${album.dataset.albumTitle || 'this album'}`;
          filterSongs();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticker-wall"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sticker-filter]');
    if (!button) return;
    const wall = button.closest('[data-sticker-wall]');
    if (!wall) return;

    const selected = button.dataset.stickerFilter;
    let visible = 0;
    wall.querySelectorAll('[data-sticker-filter]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    wall.querySelectorAll('[data-sticker-card]').forEach((card) => {
      const groups = card.dataset.groups.trim().split(/\s+/);
      const show = selected === 'all' || groups.includes(selected);
      card.hidden = !show;
      if (show) visible += 1;
    });

    const count = wall.querySelector('[data-sticker-count]');
    const empty = wall.querySelector('[data-sticker-empty]');
    if (count) count.textContent = String(visible);
    if (empty) empty.hidden = visible !== 0;
  });

  } catch(e) { console.error(e); }
})();
})();
